function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#05B8EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.45 8.053h2.61V5.45c0-.359.29-.65.65-.65h2.596a.65.65 0 01.648.65v2.602h2.596c.36 0 .65.291.65.65v2.601a.65.65 0 01-.65.652h-2.596v2.595c0 .36-.29.65-.648.65H8.709a.65.65 0 01-.65-.65v-2.595H5.452a.65.65 0 01-.651-.652v-2.6a.65.65 0 01.65-.65z",
  fill: "#FFF"
}))));